import SourceMappings from './SourceMappings';

export default SourceMappings;
